"use client";
import { supportedChainIds } from "@/constants/project-specific";
import { AnimatePresence, motion } from "motion/react";
import { useConnection } from "wagmi";
import Aggregator from "./_Aggregator";
import type { TokenConfigType } from "@/constants/types/currency";
import type { ChainId } from "@/constants/chain-specific/chains";

interface AggChainProps {
  inToken?: TokenConfigType;
  outToken?: TokenConfigType;
  targetChainId?: ChainId;
}

const AggChain = ({ inToken, outToken, targetChainId }: AggChainProps) => {
  const { chainId, chain, isConnected } = useConnection();

  return (
    <AnimatePresence>
      <div key="aggregator" className="flex pb-0 justify-center w-full">
        <Aggregator inToken={inToken} outToken={outToken} display={{ showBubbles: false, showTicker: false }} />
      </div>
      {chainId && supportedChainIds.aggregator.includes(chainId) ? null : chainId ? (
        <div key="chain-warning" className="flex flex-col w-full place-content-center pt-8">
          <span className="text-center text-lg font-semibold">
            {chain?.name ? `${chain.name} Chain` : `Chain Id ${chainId}`} Not
            Currently Supported for Aggregator!
          </span>
          <div className="text-center text-lg font-semibold">
            Please Switch to Shibarium in your wallet
          </div>
        </div>
      ) : null}
    </AnimatePresence>
  );
};

export default AggChain;